import {queryOptions} from '@tanstack/react-query';
import {unwrap} from 'framework';
import type {WorkoutsDependencies} from '../dependencies';
import {keys} from './keys';

export type GetFocusModePreferenceQueryDependencies = Pick<WorkoutsDependencies, 'controllers'>;

export const getFocusModePreferenceQuery = ({
  controllers,
}: GetFocusModePreferenceQueryDependencies) =>
  queryOptions({
    queryKey: keys.focusMode(),
    queryFn: () => controllers.workoutController.getFocusModePreference().then(unwrap),
    staleTime: Number.POSITIVE_INFINITY,
  });
